import { render, staticRenderFns } from "./card-notice.vue?vue&type=template&id=662f962f&scoped=true&"
import script from "./card-notice.vue?vue&type=script&lang=js&"
export * from "./card-notice.vue?vue&type=script&lang=js&"
import style0 from "./card-notice.vue?vue&type=style&index=0&id=662f962f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662f962f",
  null
  
)

export default component.exports